export class Configuracion {
    public Costo_Dos_Terminales?: number;
    public Tc_Dolar?: number;
    public Mostrar_Precio_Tours?: number;
}
